import { Alert } from '@one-thd/sui-atomic-components';
import React from 'react';
import '../../../styles/order-details.scss';
// prop is not required if we are only using generic error message
var errorMessage = 'We were unable to retrieve your shipment details. Refresh the page and try again.'; // move to constant file.
export var TrackShipmentError = function () {
    return (React.createElement("div", { className: "track-shipment-alert" },
        React.createElement(Alert, { status: "error", size: "large" },
            errorMessage,
            ' ')));
};
